import { render, staticRenderFns } from "./ComfirmOrder.vue?vue&type=template&id=1d1ab4bf&scoped=true&"
import script from "./ComfirmOrder.vue?vue&type=script&lang=js&"
export * from "./ComfirmOrder.vue?vue&type=script&lang=js&"
import style0 from "./ComfirmOrder.vue?vue&type=style&index=0&id=1d1ab4bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1ab4bf",
  null
  
)

export default component.exports